<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">Notice</h5>
        <p class="component-paragraph">
          You have made changes to your input, these changes are not applied to
          your current solution. If you want to apply them to a solution, you
          have to delete your current solution and create a new one.
        </p>
        <div class="component-checkbox">
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input
                id="dont-show-again"
                type="checkbox"
                class="custom-control-input"
                v-model="dontShowAgain"
              />
              <label class="custom-control-label" for="dont-show-again">
                Don't show again
              </label>
            </div>
          </div>
        </div>
        <div class="component-button">
          <input
            type="button"
            class="btn btn-secondary"
            value="Overwrite current solution"
            @click="onOverwriteCurrentSolution"
          />
        </div>
        <div class="component-button pt-3">
          <input
            type="button"
            class="btn btn-outline-secondary"
            value="Add to new solution"
            @click="onAddToNewSolution"
          />
        </div>
        <div class="component-button pt-3">
          <input
            v-focus
            type="button"
            class="btn btn-outline-secondary"
            value="Undo"
            @click="onUndo"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "ChangedInputWithSolutionModal",
  computed: {
    dontShowAgain: {
      get() {
        return this.$store.getters["brain/ui/dontShowChangedInputModal"];
      },
      set(value) {
        this.$store.commit("brain/ui/setDontShowChangedInputModal", value);
      }
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    onOverwriteCurrentSolution() {
      this.show = false;
      this.$emit("overwriteCurrentSolution");
    },
    onAddToNewSolution() {
      this.show = false;
      this.$emit("addToNewSolution");
    },
    onUndo() {
      this.show = false;
      this.$emit("undo");
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph {
    font-size: 16px;
  }
  .form-control {
    margin: 0 0 30px 0;
  }
  .component-checkbox {
    margin: 0 0 5px 0;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
